var map = {
	"./asset-hyperlink.json": "voVF",
	"./blockquote.json": "VW32",
	"./document.json": "hEbD",
	"./embedded-asset-block.json": "LbM4",
	"./embedded-entry-block.json": "VRLQ",
	"./embedded-entry-inline.json": "OhFz",
	"./embedded-resource-block.json": "l3ez",
	"./embedded-resource-inline.json": "fLu4",
	"./entry-hyperlink.json": "uBGl",
	"./heading-1.json": "DxEW",
	"./heading-2.json": "W2tf",
	"./heading-3.json": "PjSD",
	"./heading-4.json": "6pNf",
	"./heading-5.json": "Lu10",
	"./heading-6.json": "dUzI",
	"./hr.json": "WTB8",
	"./hyperlink.json": "f2Av",
	"./list-item.json": "Zw5A",
	"./ordered-list.json": "1Sql",
	"./paragraph.json": "bx8b",
	"./resource-hyperlink.json": "YxRR",
	"./table-cell.json": "IRqm",
	"./table-header-cell.json": "VroV",
	"./table-row.json": "3Fyd",
	"./table.json": "F/iF",
	"./text.json": "6zL1",
	"./unordered-list.json": "A84c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wNLN";